export default __webpack_public_path__ + "static/media/uses-background.d198197d.mp4";